<template>
  <el-dialog @keyup.enter.native="save" title="Profil" :visible.sync="open" :before-close="close" :append-to-body="true" width="300px">
    <div class="section-profil">
      <div class="form-group">
        <label>Firstname</label>
        <input type="text" v-model="profil.fname">
      </div>
      <div class="form-group">
        <label>Lastname</label>
        <input type="text" v-model="profil.lname">
      </div>
      <div class="form-group">
        <label>Email</label>
        <input type="text" v-model="profil.email" disabled>
      </div>
      <div class="form-group">
        <a @click="resetPassword">Change password</a>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" plain >{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="save" :loading="isSaving">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'profil-form',

  props: {
    open: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      profil: {},
      isSaving: false
    }
  },
  computed: {
    ...mapGetters('user', {
      me: 'me'
    }),
    ...mapState('user', {
      token: 'token'
    })
  },
  watch: {
    me: {
      handler: 'init',
      immediate: true
    }
  },
  methods: {
    init () {
      if (this.me) {
        this.profil = this._.cloneDeep(this.me, true)
      }
    },
    save () {
      this.$store.dispatch('user/updateUser', {
        user: this.profil,
        token: this.token
      }).then(() => {
        this.$notify({title: 'Success', message: this.$root.$t('notifications.user.profileEdited')})
        this.close()
      }).catch((response) => {
        this.$notify.error({
          title: this.$root.$t('api.' + response.code + '.title'),
          message: this.$root.$t('api.' + response.code + '.message')
        })
      })
    },
    close () {
      this.isSaving = false
      this.$emit('close')
    },

    resetPassword () {
      let token = encodeURIComponent(this.token)

      this.$store.dispatch('user/logout').then(() => {
        let url = '/activate?confirmcode=' + token
        this.$router.push(url)
      })
    }
  }
}
</script>

<style lang="scss">
.section-profil {
    input {
        width: 100%;
    }
    a {
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/profile/Index.vue